




























export default {
    props: {
        to: {
            required: false,
            default: false,
            type: Boolean,
        },
        spans: {
            required: false,
            default: () => [5, 5, 8],
            type: Array,
        },
        gutter: {
            required: false,
            default: 30,
            type: Number,

        },
    },
};
